/**
 * WithdrawalPage - Full withdrawal flow page
 *
 * Combines:
 * - WalletLanding in transitioned state (logo up, sparkles rotated)
 * - WithdrawalSection content below
 */

import { WithdrawalSection, type WithdrawalSubmitResult } from './WithdrawalSection';

// ============================================
// TYPES
// ============================================

export interface WithdrawalPageProps {
  /** Minimum withdrawal amount */
  minAmount?: number;
  /** Callback when withdrawal is submitted - returns success/failure */
  onSubmit?: (cardNumber: string, amount: number) => Promise<WithdrawalSubmitResult>;
  /** Back to landing handler */
  onBack?: () => void;
}

// ============================================
// COMPONENT
// ============================================

export function WithdrawalPage({
  minAmount = 50,
  onSubmit,
  onBack,
}: WithdrawalPageProps) {
  return (
    <div className="wallet-landing wallet-landing--transitioned">
      {/* Back Button */}
      {onBack && (
        <button
          onClick={onBack}
          className="fixed top-4 left-4 z-50 p-2 opacity-70 hover:opacity-100 transition-opacity"
          aria-label="Go back"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M19 12H5M5 12L12 19M5 12L12 5"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      )}

      {/* Background */}
      <div className="wallet-landing__bg" />

      {/* Animated sparkles (rotated) */}
      <div className="wallet-sparkles wallet-sparkles--rotated">
        <span className="sparkle sparkle--1" />
        <span className="sparkle sparkle--2" />
        <span className="sparkle sparkle--3" />
        <span className="sparkle sparkle--4" />
        <span className="sparkle sparkle--5" />
        <span className="sparkle sparkle--6" />
        <span className="sparkle sparkle--7" />
        <span className="sparkle sparkle--8" />
        <span className="sparkle sparkle--9" />
        <span className="sparkle sparkle--10" />
        <span className="sparkle sparkle--11" />
      </div>

      {/* Content */}
      <div className="wallet-landing__content">
        {/* Logo Section (moved up) */}
        <div className="wallet-landing__logo-section wallet-landing__logo-section--up">
          <img
            src="/images/alov-logo.png"
            alt="ALOV Champion Club"
            className="wallet-landing__logo"
          />
        </div>

        {/* Withdrawal Content */}
        <WithdrawalSection
          minAmount={minAmount}
          onSubmit={onSubmit}
          onBack={onBack}
        />
      </div>
    </div>
  );
}
